import { useLocation, Outlet } from "react-router-dom";
import {
  Briefcase, FileBarChart, Table2, Languages, Mic, ShieldCheck, Bot, PenTool, FileText
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";
import useTranslation from "@/hooks/useTranslation";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = (t) => [
  {
    id: "files",
    label: t("Reports Generator"),
    icon: FileBarChart,
    path: "/smart-office/files",
    description: t("AI-powered reports & document intelligence")
  },
  {
    id: "excel",
    label: t("Power Excel"),
    icon: Table2,
    path: "/smart-office/excel",
    description: t("AI-powered spreadsheet assistant")
  },
  {
    id: "translate",
    label: t("Translate"),
    icon: Languages,
    path: "/smart-office/translate",
    description: t("Global & African Languages translation")
  },
  {
    id: "transcribe",
    label: t("Transcribe"),
    icon: Mic,
    path: "/smart-office/transcribe",
    description: t("Audio & video transcription")
  },
  {
    id: "transcribe-b",
    label: t("Transcription B"),
    icon: Bot,
    path: "/smart-office/transcribe-b",
    description: t("Qwen 3 transcription")
  },
  {
    id: "ai-editor",
    label: t("AI Editor"),
    icon: PenTool,
    path: "/smart-office/ai-editor",
    description: t("AI-powered editing & tone adjustment")
  },
  {
    id: "doc-converter",
    label: t("Doc Converter"),
    icon: FileText,
    path: "/smart-office/doc-converter",
    description: t("Convert documents & OCR images")
  },
  {
    id: "workdocs",
    label: t("WorkDocs"),
    icon: FileText,
    path: "/smart-office/workdocs",
    description: t("AI-native document creation & editing")
  }
];

export default function SmartOfficeLayout() {
  const location = useLocation();
  const currentPath = location.pathname;
  const { t } = useTranslation();

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS(t)}
        title="SMART OFFICE"
        subtitle="AI-Powered Workspace"
        icon={Briefcase}
        gradient="from-rose-500 to-orange-500"
        activeBg="bg-rose-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
